export {default} from './UploadSpecificPhoto';
